import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConditionComponent } from './condition/condition.component';
import { GroupComponent } from './group/group.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { AdvancedSearchComponent } from './advanced-search.component';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatTooltipModule } from '@angular/material/tooltip';
import { GtagModule } from 'angular-gtag';
import { MatRippleModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';


@NgModule({
    declarations: [ConditionComponent, GroupComponent, AdvancedSearchComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatAutocompleteModule,
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        MatMenuModule,
        DragDropModule,
        MatTooltipModule,
        GtagModule,
        MatRippleModule,
        MatSelectModule
    ],
    exports: [AdvancedSearchComponent]
})
export class AdvancedSearchModule {}
